import React, { Fragment, useState } from 'react';
import { Actions, WarningMessageModal, Button, Icon, MobileStrip, Tabs, MobileItemList } from 'Components';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import history from 'src/history';
import './JobsMobile.css';

const JobsMobile = (props) => {
  const mobileKeys = {
    fixedkeys: props.data.tabIndex === 0 ? [
      ...(props.receivedJobs.keys || []).slice(0, 2), 'ReceivedDate', 'Submitted']
      : [
        ...(props.submittedJobsKeyPairs.keys || []).slice(0, 2), 'LastModified', 'StatusName'],
    bodyKeys: props.data.tabIndex === 0 ?
      (props.receivedJobs.keys || []).slice(2, 8)
      : (props.submittedJobsKeyPairs.keys || []).slice(3, 7),
    uniqueKey: props.data.tabIndex === 0 ? ' MaxxamJobNumber' : 'SubmissionId',
    code: 'job',
  };

  const samplesMobileKeys = {
    fixedkeys: [...(props.samples.keys || []).slice(0, 2), 'ReportID', 'JobNumber'],
    bodyKeys: (props.samples.keys || []).slice(2, 8),
    uniqueKey: 'ReportID',
    code: 'sample',
  };
  const [section, setSectionName] = useState('');
  const [isWarningMessageOpen, setOpenWarningMessage] = useState(false);

  const handleProceed=() => {
    props.history.push('/submissions/new')
    setOpenWarningMessage(false);
  }
  const handleCancle = ()=> {
    setOpenWarningMessage(false);
  }
  const handlOnClick = () => {
    
     if (props.isSubmissionWarningON === 'ON') {
       setSectionName('Submission')
      setOpenWarningMessage(true);

    } else {
      history.push('/submissions/new');
    }
   
  }

  return (
    <div className="jobs-mobile">
      <MobileStrip
        title={i18n.t('head:Jobs')}
        left="/templates"
        right="/supplies"
      />
      <div className="jobs-mobile__mobile-belt" >
        { props.isGlobalSearch ?
          <Fragment>
            <Actions.ClearSearch to="/jobs" />
            <Tabs
              index={props.globalSearchIndex}
              tabs={props.globalSearchTabs}
              onClick={i => props.setPageState({ globalSearchIndex: i })}
              className="tabs__button"
            />
          </Fragment>
          :
          <Fragment>
            <Button onClick={handlOnClick} className="jobs-mobile__new-job">
              <span>{i18n.t('common:New Job')}</span>
              <Icon icon="add_circle" />
            </Button>
            <Tabs
              onClick={props.handleTabClick}
              tabs={props.tabs.filter((item, index) => index <= 1)}
              labels={props.tabs.map(tab => i18n.t(`jobs:${tab}`))}
              index={props.data.tabIndex >= 2 ? 1 : props.data.tabIndex}
              className="tabs__button"
            />
          </Fragment>
        }
      </div>
      {props.globalSearchIndex === 0 ? <MobileItemList
        mobileKeys={mobileKeys}
        setPageState={props.setPageState}
        data={props.data}
        powerTableIndex={props.powerTableIndex}
        onOptionClick={props.onOptionClick}
        keyPairs={
          props.data.tabIndex === 0 ?
            props.receivedJobs.keyPairs : props.submittedJobsKeyPairs.keyPairs
        }

        noInfoTitleText={i18n.t('jobs:NoJobs')}
        noInfoSubText={i18n.t('jobs:NewJob1')}
        noInfoLinkText={i18n.t('jobs:NewJob')}
        noInfoLink="/submissions/new"
        isSupplyWarningON={props.isSupplyWarningON}
        isTemplateWarningON={props.isTemplateWarningON}
        isSubmissionWarningON={props.isSubmissionWarningON}
        isPrepaid={props.isPrepaid}
      /> :
      <MobileItemList
        mobileKeys={samplesMobileKeys}
        setPageState={props.setPageState}
        data={props.samples}
        powerTableIndex={props.powerTableIndex}
        onOptionClick={(code, i) => props.onOptionClick(code, i, true)}
        keyPairs={props.samples.keyPairs}

        noInfoTitleText={i18n.t('jobs:NoResults')}
        noInfoSubText={i18n.t('jobs:NoResultsBody')}
        isSupplyWarningON={props.isSupplyWarningON}
        isTemplateWarningON={props.isTemplateWarningON}
        isSubmissionWarningON={props.isSubmissionWarningON}
        isPrepaid={props.isPrepaid}
      />}
      <div>
        { isWarningMessageOpen &&
        <WarningMessageModal
          onProceed={handleProceed}
          onCancel={handleCancle}
          section={section}
        />
        }
      </div>
    </div>
  );
};

JobsMobile.propTypes = {
  setPageState: PropTypes.func,
  powerTableIndex: PropTypes.number,
  isGlobalSearch: PropTypes.bool,
  onOptionClick: PropTypes.func,
  handleTabClick: PropTypes.func,
  tabs: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.shape({
    isLoading: PropTypes.bool,
    tabIndex: PropTypes.number,
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  receivedJobs: PropTypes.shape({
    keyPairs: PropTypes.shape({}),
    keys: PropTypes.arrayOf(PropTypes.string),
  }),
  submittedJobsKeyPairs: PropTypes.shape({
    keyPairs: PropTypes.shape({}),
    keys: PropTypes.arrayOf(PropTypes.string),
  }),
  samples: PropTypes.shape({
    pageSize: PropTypes.number,
    totalItems: PropTypes.number,
    isLoading: PropTypes.bool,
    data: PropTypes.arrayOf(PropTypes.shape({})),
    tabIndex: PropTypes.number,
    pageNumber: PropTypes.number,
    keyPairs: PropTypes.shape({}),
    keys: PropTypes.arrayOf(PropTypes.string),
  }),
  globalSearchIndex: PropTypes.number,
  globalSearchTabs: PropTypes.arrayOf(PropTypes.string),
  isSupplyWarningON: PropTypes.bool,
  isTemplateWarningON: PropTypes.bool,
  isSubmissionWarningON: PropTypes.bool,
};
export default JobsMobile;



// WEBPACK FOOTER //
// ./src/containers/Jobs/JobsMobile/JobsMobile.jsx